import { createAction } from 'redux-act';

export const fetchQuestionList = createAction('fetch question-list');
export const failQuestionList = createAction('fail question-list');
export const successQuestionList = createAction('success question-list');

export const fetchUpdateQuestionList = createAction(
  'fetch update question-list'
);
export const failUpdateQuestionList = createAction('fail update question-list');
export const successUpdateQuestionList = createAction(
  'success update question-list'
);

export const setMarker = createAction('set marker');
export const failSetMarker = createAction('fail set marker');
export const successSetMarker = createAction('success set marker');

export const setListedQuestions = createAction('set listed questions');

export const setSearchDisplayType = createAction('set search display type');
export const setSearchDisplayOption = createAction('set search display option');

export const setQuestionIndex = createAction('set question index');

export const setQuestionImagePath = createAction('set question image path');
export const setExplanationImagePath = createAction(
  'set explanation image path'
);



// WEBPACK FOOTER //
// ./src/actions/question.js